import React, { Suspense, lazy } from 'react'
import type { ComponentProps } from 'react'

// Lazy-load `@lottiefiles/react-lottie-player` (~335 KB raw / ~80 KB gz) so
// it never lands in the initial-load chunk. The buddy widget in the main
// app shell (`AssistantBuddy`) and several synthesis-step success animations
// import this — they all render asynchronously after first paint.
const Player = lazy(() =>
  import('@lottiefiles/react-lottie-player').then((m) => ({ default: m.Player })),
)

export type LottiePlayerProps = ComponentProps<typeof Player>

export const LottiePlayer: React.FC<LottiePlayerProps> = (props) => (
  <Suspense fallback={null}>
    <Player {...props} />
  </Suspense>
)

export default LottiePlayer
